import _ from 'lodash'
import React, { createElement } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { toBassNumber } from '../theme'
import mapProps from '../theme/mapProps'
import mapMarginPaddingProps from '../theme/mapMarginPaddingProps'

import Text, { mapTextProps } from './Text'

const SCALE = {
  [-3]: [0.625, 1],
  [-2]: [0.75, 1.25],
  [-1]: [0.875, 1.25],
  [0]: [1, 1.5],
  [1]: [1.25, 1.5],
  [2]: [1.5, 2],
  [3]: [2, 2.5],
  [4]: [2.5, 3],
  [5]: [3.5, 4],
  [6]: [4.325, 4.5],
  [7]: [4.5, 4.5],
  [8]: [5, 4.5],
  cover: [3.75, 4.375],
}

export const mapTitleProps = mapProps({
  caps: {
    narrow: css`
      letter-spacing: 0;
      text-transform: uppercase;
    `,
    default: css`
      letter-spacing: 0.0625rem;
      text-transform: uppercase;
    `,
  },

  weight: {
    black: css`
      font-weight: 900;
    `,
    bold: css`
      font-weight: 700;
    `,
    normal: css`
      font-weight: 600;
    `,
    light: css`
      font-weight: 400;
    `,
    ultralight: css`
      font-weight: 300;
    `,
  },

  color(color, prop, { theme }) {
    let themeColor = theme[color] || (theme.colors && theme.colors[color])
    if (themeColor) {
      return css`
        color: ${themeColor};
      `
    } else {
      return css`
        color: ${color};
      `
    }
  },

  scale: _.mapValues(SCALE, ([size, height]) => {
    height = height == null ? size : height

    return css`
      font-size: ${size}rem;
      line-height: ${({ lineHeight }) => {
        if (lineHeight != null) {
          return toBassNumber(lineHeight) + height
        }

        return height
      }}rem;
    `
  }),

  height(lines, prop, { scale }) {
    let [size, height = size] = SCALE[scale] || SCALE[0]

    return (
      height &&
      css`
        min-height: calc(${lines * height} * 1rem);
      `
    )
  },

  lines(lines, prop, { scale, children }) {
    const words = _.words(children)
    const avg = _.sumBy(words, 'length') / words.length

    const [size] = SCALE[scale] || [1]

    // scale = (scale || 1) * (scaleList[scale] || 1);

    // or 1.5 and 3rem
    return css`
      max-width: calc(${_.round(size * (words.length / lines), 2) * (avg > 4.5 ? 1.1 : 1)} * 2.7rem);
    `
  },
})

export const Title = styled(({ h, ...p }) => createElement(h ? `h${h}` : 'div', p))`
  text-transform: initial;
  letter-spacing: initial;
  margin: inital;

  max-width: 36rem;

  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;

  white-space: pre-wrap;

  color: $theme.textColor;

  ${mapMarginPaddingProps};
  ${mapTextProps};
  ${mapTitleProps};
`

export default Title



// WEBPACK FOOTER //
// ./src/styleguide/Title.js